var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.44 7.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e95c28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3.72,
    cy: 3.72,
    r: 3.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.72,5.75s-.01-.02-.02-.02c-.12-.18-.24-.37-.36-.55-.22-.34-.43-.67-.64-1.02-.08-.14-.17-.28-.25-.42-.04-.07-.07-.14-.09-.21-.02-.07-.04-.15-.05-.23-.01-.08-.02-.15-.02-.23,0-.63.44-1.17,1.03-1.34.09-.02.18-.04.27-.05.07,0,.14,0,.21,0,.31.02.58.13.82.33.22.19.37.43.45.71.02.08.04.16.04.24,0,.07,0,.15,0,.22,0,.1-.02.2-.05.3,0,.03-.02.07-.03.1-.01.04-.03.08-.06.12-.07.13-.15.26-.23.38-.2.34-.41.67-.62,1-.13.21-.27.42-.4.62,0,0-.01.02-.02.03Zm.62-2.65c0-.34-.28-.62-.62-.62-.34,0-.62.27-.62.62,0,.34.28.62.62.62.34,0,.62-.28.62-.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/Location icon.28431ed58b0f24da7851c5aa248f18d5.svg";
export { ForwardRef as ReactComponent };